module.exports = __webpack_public_path__ + "img/down_arrow.1e26dd7d.svg";